import type { LiveSearchAGGQueryNode } from '../API/AGGSearchTypes.ts';
import type { liveSearchAGGResult } from '../API/handleAGGSearch.tsx';

import { CONTEXT_PATH } from './aggVariables.ts';

export const aggResultMapper = ({
	node: result,
}: {
	node: LiveSearchAGGQueryNode;
}): liveSearchAGGResult => ({
	id: result.id,
	title: result.title,
	excerpt: result.excerpt || '',
	spaceName: result.space?.name || '',
	type: result.type,
	url: parseAggUrl(result.url),
});

export const parseAggUrl = (url: string): string => {
	const splitUrl = url.split(CONTEXT_PATH);
	return splitUrl[splitUrl.length - 1];
};
